<div class="category-select">
  <section>
    <p
      class="category-select__label"
      [ngClass]="{
        'category-select__label--no-margin-top': noMarginTop,
      }"
    >
      {{ labelSelect }}
    </p>
    <app-pills [pills]="pills" (changed)="pillsChanged($event[0])"></app-pills>
    <div
      class="category-select__subpills d-flex gap-10 flex-wrap-wrap"
      *ngIf="selectedCategory"
    >
      <app-button
        variant="secondary"
        size="small"
        *ngFor="let subCategory of selectedCategory.children"
        (click)="selectSubCategory(subCategory)"
      >
        <app-icon *ngIf="subCategorySelected(subCategory.id)">check</app-icon>
        {{ subCategory.name }}
      </app-button>
    </div>
  </section>
  <section
    class="category-select__section category-select__selected"
    *ngIf="selectedCategory && selectedSubCategories?.length"
  >
    <p class="category-select__label">{{ labelSelected }}</p>
    <app-chip-list>
      <app-chip
        *ngFor="let selectedSubCategory of selectedSubCategories"
        [removable]="true"
        (removed)="selectSubCategory(selectedSubCategory)"
      >
        {{ selectedSubCategory.name }}
        <app-icon remove-icon>cancel</app-icon>
      </app-chip>
    </app-chip-list>
  </section>
</div>
